module.exports = __webpack_public_path__ + "img/idp_cert2.c4de6cb0.jpg";